export default __webpack_public_path__ + "static/media/reliancestandard-logo.20938768.png";